import styled, { css, DefaultTheme } from 'styled-components';
import type { NotificationBannerStyledProps } from './NotificationBanner.typed';

const getBackgroundColor = (
  intent: NotificationBannerStyledProps['intent'],
  theme: DefaultTheme,
): string => {
  switch (intent) {
    case 'info':
      return '#F1E6FF'; // TODO: Add to theme
    case 'success':
      return theme.brand.tertiary.lighter;
    case 'error':
      return '#FBE2E2'; // TODO: Add to theme
    case 'warning':
      return theme.brand.warning.lighter;
    default:
      return theme.brand.secondary.lighter;
  }
};

const getColor = (
  intent: NotificationBannerStyledProps['intent'],
  theme: DefaultTheme,
): string => {
  switch (intent) {
    case 'info':
      return theme.brand.secondary.darker;
    case 'success':
      return theme.brand.secondary.darker;
    case 'error':
      return theme.brand.secondary.darker;
    case 'warning':
      return theme.brand.secondary.darker;
    default:
      return theme.brand.secondary.dark;
  }
};

const getIconColor = (
  intent: NotificationBannerStyledProps['intent'],
  theme: DefaultTheme,
): string => {
  switch (intent) {
    case 'info':
      return theme.brand.primary.base;
    case 'success':
      return theme.brand.success.base;
    case 'error':
      return theme.brand.error.base;
    case 'warning':
      return theme.brand.warning.dark;
    default:
      return theme.brand.secondary.base;
  }
};

export const NotificationBanner = styled.div<NotificationBannerStyledProps>(
  ({ theme, elevated, intent, size }) => css`
    display: flex;
    align-items: start;
    padding: ${size === 'm'
      ? theme.spacing.M16
      : `${theme.spacing.S4} ${theme.spacing.S8}`};
    border-radius: 4px;
    background: ${getBackgroundColor(intent, theme)};
    color: ${getColor(intent, theme)};
    font-size: ${theme.typography.fontSizes.S12};

    ${size === 'm' &&
    css`
      @media screen and (min-width: ${theme.breakpoints['md']}px) {
        font-size: ${theme.typography.fontSizes.M14};
      }
    `}

    ${Icon} {
      color: ${getIconColor(intent, theme)};
    }

    ${elevated &&
    css`
      box-shadow: ${theme.shadow.primary};
    `};
  `,
);

export const Body = styled.div`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
`;

export const Icon = styled.div(
  ({ theme }) => css`
    flex: 0 0 auto;
    margin-right: ${theme.spacing.S8};
  `,
);

export const Close = styled.button`
  margin-left: ${({ theme }) => theme.spacing.S8};
  color: ${({ theme }) => theme.brand.secondary.base};
`;
